@if(!dataLoaded()){
<div class="flex flex-col justify-center items-center h-full w-full">
  <span class="fs-3 mr-5">{{"PROVIDER_PEER_COMPARISONS.LOADING" | translate}}</span>
  <span class="text-xl spinner-border spinner-border-lg align-middle"></span>
</div>
} @else{
<app-dashboard-header />
<div class="flex flex-col gap-5">
  
  <div class="">
    <dashboard-filters></dashboard-filters>
  </div>
  <!--begin:Claim Rate By Hospital Chart -->
  <div class="grid grid-cols-1 md:grid-cols-1 gap-4">
    <app-spline-chart
      cssClass="h-full flex flex-col"
      [chartCase]="'PROVIDER_PEER_COMPARISONS.CLAIM_RATE_BY_HOSPITAL' | translate"
      [graphTitles]="claimRateByProvider.providers"
      [graphData]="claimRateByProvider.dateAmount"
      [xKey]="'title'"
      [yKey]="'amounts'"
      height="400"
      [isXLabels]="true"
      [isYLabels]="true"
    ></app-spline-chart>

    <!--end:Claim Rate By Hospital Chart -->

    <paginated-table
      class="h-full card"
      [cardTitle]="'PROVIDER_PEER_COMPARISONS.SUMMARY_OF_CLAIMS_BY_CLINIC' | translate"
      [headers]="claimsByClinic.providers"
      [tableData]="claimsByClinic.clinicAmount"
      [keys]="['clinic', 'amounts']"
      [types]="['TITLE', 'ARRAY']"
      [pageSize]="7"
    ></paginated-table>
  </div>

  <paginated-table
    class="text-center card"
    [cardTitle]="'PROVIDER_PEER_COMPARISONS.SUMMARY_OF_CLAIMS_BY_HEALTH_PROVIDER' | translate"
    [headers]="provClaimHeaders"
    [tableData]="providerClaims"
    [keys]="[
      'healthProvider',
      'claimVolume',
      'claimVolumePercentage',
      'totalClaimsPrice',
      'totalClaimsPercentage'
    ]"
    [types]="['TITLE', 'NUMBER', 'PERCENTAGE', 'CURRENCY', 'PERCENTAGE']"
    [pageSize]="7"
  ></paginated-table>

  <!--end:Claim Rate Chart -->

  <!--begin::Case type chart -->

  <paginated-table
    class="text-center card"
    [cardTitle]="'PROVIDER_PEER_COMPARISONS.DISTRIBUTION_OF_MEDICAL_EXPENSES' | translate"
    [headers]="medicalExpensesDistHeaders"
    [tableData]="medicalExpPerc"
    [keys]="[
      'healthProvider',
      'medicalSuppliesPercentage',
      'specialMedicalSuppliesPercentage',
      'hospitalizationPercentage',
      'medicalExaminationsPercentage',
      'surgeryExpensesPercentage',
      'physicianFeesPercentage',
      'otherExpensesPercentage'
    ]"
    [types]="[
      'TITLE',
      'PERCENTAGE',
      'PERCENTAGE',
      'PERCENTAGE',
      'PERCENTAGE',
      'PERCENTAGE',
      'PERCENTAGE',
      'PERCENTAGE'
    ]"
    [pageSize]="pageSize"
    [serverPaging]="true"
    [totalRecords]="total"
    [loading]="loading"
    (lazyLoad)="loadMedicalExpenses($event)"
  ></paginated-table>
  <paginated-table
    class="text-center card"
    [cardTitle]="'PROVIDER_PEER_COMPARISONS.AVERAGE_CLAIM_AMOUNT' | translate"
    [headers]="avgClaimPerDRG.providers"
    [tableData]="avgClaimPerDRG.drgAmount"
    [keys]="['drg', 'amounts']"
    [types]="['TEXT', 'ARRAY']"
    [pageSize]="10"
  ></paginated-table>
  <paginated-table
    class="text-center card"
    [cardTitle]="'PROVIDER_PEER_COMPARISONS.AVERAGE_HOSPITALIZATION_DURATION' | translate"
    [headers]="hospDurationPerDRG.providers"
    [tableData]="hospDurationPerDRG.drgAmount"
    [keys]="['drg', 'amounts']"
    [types]="['TEXT', 'ARRAY']"
    [pageSize]="10"
  ></paginated-table>
</div>
}
